import { render, staticRenderFns } from "./LeisureGameIframView.vue?vue&type=template&id=832bcf98&scoped=true&"
import script from "./LeisureGameIframView.vue?vue&type=script&lang=js&"
export * from "./LeisureGameIframView.vue?vue&type=script&lang=js&"
import style0 from "./LeisureGameIframView.vue?vue&type=style&index=0&id=832bcf98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832bcf98",
  null
  
)

export default component.exports